module.exports = __webpack_public_path__ + "img/teacher.d61ded6b.jpeg";